import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { isFlightLogUrl, isTcsUrl } from '../app.config';
import { CurrentUserService } from './current-user.service';

@Injectable()
export class ImpersonationInterceptor implements HttpInterceptor {
  constructor(private _user: CurrentUserService) {}
  public intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const imp = this._user.impersonated.value;
    if (imp != null) {
      const impId = isTcsUrl(req.url)
        ? imp.employee.tcsId
        : isFlightLogUrl(req.url)
        ? imp.id
        : undefined;

      if (impId != null) {
        // eslint-disable-next-line @typescript-eslint/naming-convention
        req = req.clone({ setHeaders: { 'x-user-id': impId } });
      }
    }
    return next.handle(req);
  }
}
